// 대화 원장의 표시는 message-server가 주는 식별자와 space-home의 멤버 목록을
// 결합한다. Message 계약에는 authorNodeId만 있으므로, 여기서 이름을 임의로 만들지 않는다.

export function isAiMessage(message) {
  return Boolean(message.provenance && message.provenance !== 'human_direct');
}

// D-8은 사람 이름의 반복만 생략한다. AI 출처 표시는 매 행에 남아야 한다.
export function shouldShowMessageMeta({ repeatsAuthor, ai }) {
  return ai || !repeatsAuthor;
}

export function messageAuthorName({ authorNodeId, isMine, members }) {
  if (isMine) return '나';

  const displayName = members.find((member) => member.nodeId === authorNodeId)?.displayName;
  if (typeof displayName === 'string' && displayName.trim() !== '') return displayName;

  // 탈퇴·해제된 자리는 현재 members에 없을 수 있다. 이름을 추정하지 않고, 남은
  // 식별자 조각이 이름 부재를 뜻한다는 것을 함께 말한다.
  if (typeof authorNodeId !== 'string') return '이름을 알 수 없는 참여자';
  return `이름을 알 수 없는 참여자 ${authorNodeId.slice(-4)}`;
}
